module.exports = __webpack_public_path__ + "media/newstyle/images/diners-4c5a3ab419d27dff98e2b35be1771210.svg";